module.exports = __webpack_public_path__ + "static/media/paleta.89b32e4f.jpeg";